import {
  type BuyNowEvent,
  type SendGtmEvent
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import buyNowEvents from '@/modules/shared/utils/gtmEvents/events/buyNowEvents';
import { sendGtmEvent } from '@/modules/shared/utils/gtmEvents/Manager';

export function sendEvent({ event, extraFields }: SendGtmEvent): void {
  try {
    const eventObj: BuyNowEvent = {
      ...buyNowEvents[event],
      ...extraFields
    };

    return sendGtmEvent(eventObj);
  } catch (error) {
    console.error(`GTM: Couldn't send ${event} event`, error);
  }
}
